<template>
  <controller>
    <page-header title="Colaboradores">
      <template v-slot:side>
        <transition name="slideRightToLeft">
          <a href="#" @click.prevent="togglePlanilhas()" class="btn btn-primary" v-if="!planilha">
            <span>Enviar itens em lote</span>&nbsp;
            <fa :icon="['fas', 'file-spreadsheet']"></fa>
          </a>
        </transition>
        <transition name="slideRightToLeft">
          <a href="#" @click.prevent="togglePlanilhas()" class="btn btn-primary" v-if="planilha">
            <span>Filtrar</span>&nbsp;
            <fa :icon="['fas', 'user-tie']"></fa>
          </a>
        </transition>
        <router-link :to="{ name: 'colaboradores' }" class="btn btn-secondary" v-if="action">
          <span> <fa :icon="['far', 'arrow-left-long']"/> Voltar </span>&nbsp;
        </router-link>
        <router-link :to="{ name: 'colaboradores', params: { action: 'criar'} }" class="btn btn-primary" v-else>
          <span>Novo Colaborador</span>&nbsp;
        </router-link>
      </template>
    </page-header>
    <main>
      <planilhas-controller v-if="planilha" tipo="colaboradores" />
      <template v-else>
        <filter-controller @onFilter="runFilter" v-if="!action"/>
        <form-spinner v-if="loading" />
        <colaboradores v-else-if="!loading && colaboradores && !action" :scope="colaboradores" ></colaboradores>
        <colaborador v-if="(action == 'ver' || action == 'criar')" :id="id"/>
      </template>
    </main>
  </controller>
</template>

<script>
import PlanilhasController from '@/components/planilhas/template/PlanilhasController.vue'
import FilterController from '@/components/administrativo/colaboradores/utilities/Filter.vue'
import Colaborador from '@/components/administrativo/colaboradores/form/Colaborador.vue'
import Colaboradores from '@/components/administrativo/colaboradores/template/Colaboradores.vue'
import FormSpinner from '@/components/utilities/FormSpinner.vue'

export default {
  components: {
    PlanilhasController, FilterController, FormSpinner, Colaborador, Colaboradores
  },
  props: {
    action: {
      type: String
    },
    id: {
      type: [ Number, String ]
    },
    scope: {
      type: String
    }
  },
  watch: {
    action ( value ) {
      console.log("watch action:", value)
    }
  },
  data () {
    return {
      planilha: false,
      loading: false,
      colaboradores: null,
    }
  },
  methods: {
    togglePlanilhas () {
      this.planilha = !this.planilha
    },
    runFilter ( options ) {
      this.loading = options.wait

      if ( options.data ) {
        this.colaboradores = options.data
        console.log("options:", options)
      }
    },
  }
}
</script>

<style lang="scss" scoped>
  main{
    padding-bottom: $mg_large;
  }
</style>